import request from '@/Utilities/httpRequest';
import apiCombos from '@/api/combos';
import websiteEvents from '@/Utilities/website-events';
import {isEmpty} from 'lodash-es';
import pdpUtils from '@/store/product-page/pdp-utils';

import moduleAddToCartDesktop from '@/store/product-page/desktop-blackrabbit/add-to-cart-module';
//import addToCartDesktop
//    from '@/store/product-page/desktop-blackrabbit/add-to-cart-module';

function initialState(){
    return {
        loadUrl: null, // for changing page data on groupId option change
        lastOrderUrl: null,
        pointsUrl: null,
        homeUrl: null,
        prozisPointsUpdateUrl: null,
        //headerData: {},
        isLoading: false,
        criteoData: null,
        blockImageRecords: [],
        basicInfoData: {},
        infoSectionData: {},
        addToCartData: null,
        canCheckCombos: false,
        comboData: null,
        campaignsConnection: null,
        campaignsData: null,
        tabsData: null,
        relatedProductsBlocks: null,
        productUnavailableBlocks: null,
        productDetailBlocks: null,
        gridLayout: 1920, // 1280, 1536, 1920 && 2560 (this max 2200 wrapper, same properties as 1920)
        videoModal: {
            show: false,
            videoData: null
        },
        updateDescription: null,
        enableSideDetails: false,
        enableReverseSideDetails: false,
        enableStockAlert: false,
        scrollMinimalMode: false
    };    
}

const pdpDesktop = {
    strict: true,
    namespaced: true,
    state: initialState,
    mutations: {
        setLoadUrl(state, payload) {
            state.loadUrl = payload;
        },
        isLoading(state, payload) {
            state.isLoading = payload;
        },
        setLastOrderUrl(state, payload) {
            state.lastOrderUrl = payload;
        },
        setHomeUrl(state, payload) {
            state.homeUrl = payload;
        },
        // setHeaderData(state, payload) {
        //     state.headerData = payload;
        // },
        setProzisPointsUpdateUrl(state, payload) {
            state.prozisPointsUpdateUrl = payload;
        },
        setPointsUrl(state, payload) {
            state.pointsUrl = payload;
        },
        setCriteoData(state, payload) {
            state.criteoData = payload;
        },
        setBlockImageRecords(state, payload) {
            state.blockImageRecords = payload;
        },
        setBasicInfoData(state, payload) {
            state.basicInfoData = payload;
        },  
        setInfoSectionData(state, payload) {
            const addToCartData = state.addToCartData;
            const productInfo = addToCartData.productInfo;
            const kStrings = addToCartData.kStrings;
            state.infoSectionData = {
                name: productInfo.name,
                groupId: productInfo.groupId,
                ratingData: {
                    rating: productInfo.rating,
                    totalRatings: productInfo.ratingTotal,
                },
                points: productInfo.points,
                superPoints: productInfo.superPoints,
                prozisPointsFactor: productInfo.pointsFactor ?? 1,
                priceData: {
                    price: productInfo.minPrice,
                    priceCrossed: productInfo.pricePartner,
                    bestPriceCoupon: productInfo.bestPriceCoupon,
                },
                showLinkComments: productInfo.showLinkComments,
                stockMsg: addToCartData.hasStock ? kStrings.kIN_STOCK : kStrings.kPROD_STOCK_OUT,
                sharedData: !isEmpty(addToCartData.sharedData) ? addToCartData.sharedData : null,
                likesData: !isEmpty(addToCartData.likesData) ? addToCartData.likesData : null,
                fanLinkData: addToCartData.fanLink,
                frozenText: addToCartData.isFrozen || productInfo.isFrozen ? kStrings.kPRODUTO_CONGELADO : null,
            };
        }, 
        updateInfoSectionPartial(state, payload) {
            state.infoSectionData = Object.assign({}, state.infoSectionData, payload);
        },
        setAddToCartData(state, payload) {
            state.addToCartData = payload;
        },
        setTabsData(state, payload) {
            state.tabsData = payload;
        },
        setCanCheckCombos(state, payload) {
            state.canCheckCombos = payload;
        },
        setComboData(state, payload) {
            state.comboData = payload;
        },
        setCampaignsConnection(state, payload) {
            state.campaignsConnection = payload;
        },
        setCampaignsData(state, payload) {
            state.campaignsData = payload;
        },
        setRelatedProductsBlocks(state, payload) {
            state.relatedProductsBlocks = payload;
        },
        setProductUnavailableBlocks(state, payload) {
            state.productUnavailableBlocks = payload;
        },
        updateLike(state, payload) {
            state.infoSectionData.likesData.liked = payload.like;
        },
        setProductDetailBlocks(state, payload) {
            state.productDetailBlocks = payload;
        },
        setGridLayout(state) {
            const screenVw = window.innerWidth;
            if(screenVw < 1536) {
                state.gridLayout = 1280;
            } else if(screenVw >= 1536 && screenVw < 1920) {
                state.gridLayout = 1536;
            } else if(screenVw >= 1920 && screenVw <= 2200) {
                state.gridLayout = 1920;
            } else {
                state.gridLayout = 2560;
            }
        },
        updateVideoModal(state, payload) {
            if(!payload) {
                payload = {
                    show: false,
                    videoData: null
                }
            }

            state.videoModal = Object.assign({}, state.videoModal, payload);
        },
        setUpdateDescription(state, payload) {
            state.updateDescription = payload;
        },
        setEnableSideDetails(state, payload) {
            state.enableSideDetails = payload;
        },
        setEnableReverseSideDetails(state, payload) {
            state.enableReverseSideDetails = payload;
        },
        setEnableStockAlert(state, payload) {
            state.enableStockAlert = payload;
        },
        setScrollMinimalMode(state, payload) {
            state.scrollMinimalMode = payload;
        },
        reset(state){
          // acquire initial state
          const s = initialState()
          Object.keys(s).forEach(key => {
            state[key] = s[key]
          });
        }
    },

    actions: {
        // state, commit, dispatch, rootState, rootGetters
        initWsData(context, payload, dispatch, rootState, rootGetters) {
            try {
                context.dispatch('updateKstrings', payload.addToCart.kStrings, {root: true});
                context.commit('setLoadUrl', payload.loadUrl);
                context.dispatch('updateLastOrderUrl', payload);
                if(payload.gallery){
                    context.commit('gallery/setImagesUrl', payload.gallery.url, {root: true});
                }
                //context.commit('setHeaderData', payload.headerData);
                context.commit('setProzisPointsUpdateUrl', payload.prozisPointsUpdateUrl);
                context.commit('setPointsUrl', payload.pointsUrl);
                context.commit('setHomeUrl', payload.homeUrl);
                context.commit('setCriteoData', payload.criteoData);
                context.commit('setGridLayout');
                context.commit('setBasicInfoData', payload.basicInfo);
                if(!payload.hasOwnProperty('ignoreCartUpdate') && !payload.ignoreCartUpdate) {
                    //console.log('update cart');
                    context.commit('setAddToCartData', payload.addToCart);
                }
                context.commit('setInfoSectionData', payload);
                context.commit('setTabsData', payload.tabs);
                if(payload.hasOwnProperty('blocksColor') && payload.blocksColor) {
                    context.dispatch('updateBlocksColor', payload.blocksColor, {root: true});
                }

                // reset campaign data
                context.commit('setCampaignsData', null);
                // update campaign data URL (backend will return null if product is disabled or out of stock)
                context.commit('setCampaignsConnection', payload.campaigns);

                // base main store update
                const productInfo = payload.addToCart.productInfo;
                context.dispatch('priceCoupons/setData', payload.bestPriceCoupons ? payload.bestPriceCoupons : [], {root: true});
                if(payload.autoApplyCoupons){
                    // this should be set only one time, it's missing in AJAX requests 
                    context.dispatch('priceCoupons/setAutoApply', payload.autoApplyCoupons, {root: true});
                }
                context.dispatch('changeGroupId', {id: productInfo.groupId, masterSku: productInfo.sku}, {root: true});
                context.dispatch('gallery/setSKU', productInfo.sku, {root: true});
                context.dispatch('gallery/setGroupId', productInfo.groupId, {root: true});
                if(payload.gallery){
                    context.dispatch('gallery/updateData', payload.gallery, {root: true});
                }
                context.dispatch('addToCartDesktop/updateShowQuantityWidget', productInfo.showQuantity)
                if (payload.addToCart.hasOwnProperty('deliveryInfoUrl') &&
                    payload.addToCart.deliveryInfoUrl) {
                    context.dispatch('setDeliveryInfoUrl', payload.addToCart.deliveryInfoUrl, {root: true});
                }
                if (productInfo && payload.addToCart.hasOwnProperty('deliveryInfoSku') && payload.addToCart.deliveryInfoSku) {
                    context.dispatch('requestDeliveryInfo', {
                        groupId: productInfo.groupId,
                        varSku: payload.addToCart.deliveryInfoSku,
                        stock: payload.addToCart.hasStock,
                        groupStatus: productInfo.groupStatus
                    }, {root: true});
                }

                context.dispatch('updatePrice', {
                    price: productInfo.minPrice,
                    priceReference: productInfo.pricePartner,
                    bestPriceCoupon: productInfo.bestPriceCoupon,
                }, {root: true});
                context.dispatch('updateStockLabel', payload.basicInfo.stockMsg, {root: true});
                context.dispatch('updateHasStock', payload.basicInfo.hasStock, {root: true});

                // combos
                context.commit('setCanCheckCombos', payload.addToCart.canCheckCombos);
                /*if (payload.addToCart.canCheckCombos) {
                    context.dispatch('updateComboData', {id: productInfo.groupId, blocksColor: payload.blocksColor});
                }*/

                context.commit('setRelatedProductsBlocks', payload.relatedProducts);
                context.commit('setProductUnavailableBlocks', payload.productUnavailableBlocks);
                context.commit('setProductDetailBlocks', payload.productDetailBlocks);
                context.dispatch('setBreadcrumbs', payload.breadcrumbs, {root: true});
                if(payload.updateDescription) {
                    context.commit('setUpdateDescription', payload.updateDescription);
                }
                if(payload.enableSideDetails) {
                    context.commit('setEnableSideDetails', payload.enableSideDetails);
                }
                if(payload.enableReverseSideDetails) {
                    context.commit('setEnableReverseSideDetails', payload.enableReverseSideDetails);
                }

                if(payload.enableStockAlert) {
                    context.commit('setEnableStockAlert', payload.enableStockAlert);
                }

                if(payload.productDetailBlocks && payload.productDetailBlocks.blockImageRecords) {
                    context.dispatch('updateBlockImageRecords', payload.productDetailBlocks.blockImageRecords);
                }

                // POINTS PURCHASE ENABLE!
                // get empty data for points button
                let btnPointsData = pdpUtils.buildPointsButtonData(null, null, null);
                if(payload.hasOwnProperty('enablePointsPurchase')) {
                    // enable it
                    context.dispatch('updateEnablePointsPurchase', payload.enablePointsPurchase, {root: true});
                    if(payload.enablePointsPurchase && productInfo){
                        // get points button data
                        btnPointsData = pdpUtils.buildPointsButtonData(null, payload.addToCart.products, productInfo.sku);
                    }
                }
                context.dispatch('addToCartDesktop/updateFloatBtn', btnPointsData);
            
            } catch (e) {
                //console.log('page load failure!', e);
                if(typeof Bugsnag !== 'undefined'){
                    e = !(e instanceof Error) ? new Error(e) : e;
                    Bugsnag.notify('pdpSetData', e.message, {}, 'error');
                }
            } finally {
                context.dispatch('setLoading', false);
               /* if(!context.getters.miniPdpMode) {
                    context.dispatch('initMovingElementsBehaviour');
                }*/
            }
        },
        setLoading(context, payload) {
            context.commit('isLoading', payload);
        },
        updateLastOrderUrl(context, payload) {
            if(payload.canShowLastOrderDate) {
                setTimeout(() => {
                    context.commit('setLastOrderUrl', payload.lastOrderUrl);
                }, 1000);
            }
        },
        updateCriteoData(context, payload) {
            context.commit('setCriteoData', payload);
        },
        updateBlockImageRecords(context, payload) {
            context.commit('setBlockImageRecords', payload);
        },
        updateInfoSection(context, payload) {
            if(!isEmpty(payload)){
                context.commit('updateInfoSectionPartial', payload);
            }
        },
        updateBasicInfo(context, payload) {
            context.commit('setbasicInfoData', payload);
        },
        updateAddToCartData(context, payload) {
            context.commit('setAddToCartData', payload);
        },
        updateTabsData(context, payload) {
            context.commit('setTabsData', payload);
        },
        async updateComboData(context, payload) {
            const comboData = await apiCombos.getBlackRabbitComboById(payload.id, payload.blocksColor, payload.limit);
            if (comboData) {
                websiteEvents.eventCombo('show-block', 'PDP', null);
                context.commit('setComboData', comboData);
            } else { // ex: by changing groupId 
                context.commit('setComboData', null);
            }
        },
        async updateCampaignsData(context, payload) {
            if(payload) {
                request.cancelLastCall(payload.url);
                const { data } = await request.get(payload.url,{id: payload.groupId});
                if(data && data.hasOwnProperty('campaigns')){
                    context.dispatch('quantityBuyStruct', data.quantityBuyStruct ? data.quantityBuyStruct : [], {root: true});
                    context.commit('setCampaignsData', data);
                }
            }
        },
        updateRelatedProductsBlocks(context, payload) {
            context.commit('setRelatedProductsBlocks', payload);
        },
        initMovingElementsBehaviour() {
            const detachedContainer = document.getElementById('detachedContainer');
            const cartBuyWidget = document.getElementById('cartBuyWidget');
           /* console.log('detachedContainer',detachedContainer);
            console.log('cartBuyWidget', cartBuyWidget);*/
            if(detachedContainer && cartBuyWidget) {
                detachedContainer.append(cartBuyWidget);
            }
        },
        updateGridLayout(context) {
            context.commit('setGridLayout');
        },
        reset(context){
            context.dispatch('addToCartDesktop/reset');
            context.commit('reset');
        }        
    },
    getters: {
        loadUrl: state => state.loadUrl,
        lastOrderUrl: state => state.lastOrderUrl,
        prozisPointsUpdateUrl: state => state.prozisPointsUpdateUrl,
        pointsUrl: state => state.pointsUrl,
        homeUrl: state => state.homeUrl,
        isLoading: state => state.isLoading,
        criteoData: state => state.criteoData,
        blockImageRecords: state => state.blockImageRecords,
        basicInfoData: state => state.basicInfoData,
        infoSectionData: state => state.infoSectionData,
        addToCartData: state => state.addToCartData,
        tabsData: state => state.tabsData,
        canCheckCombos: state => state.canCheckCombos,
        comboData: state => state.comboData,
        campaignsConnection: state => state.campaignsConnection,
        campaignsData: state => state.campaignsData,
        relatedProductsBlocks: state => state.relatedProductsBlocks??[],
        productUnavailableBlocks: state => state.productUnavailableBlocks,
        productDetailBlocks: state => state.productDetailBlocks,
        gridLayout: state => state.gridLayout,
        videoModal: state => state.videoModal,
        updateDescription: state => state.updateDescription,
        enableSideDetails: state => state.enableSideDetails,
        enableReverseSideDetails: state => state.enableReverseSideDetails,
        enableStockAlert: state => state.enableStockAlert,
        scrollMinimalMode: state => state.scrollMinimalMode,
    },
    modules: {
        addToCartDesktop: moduleAddToCartDesktop,
    }
};

export default pdpDesktop;
